




























import { TerminationReasonModel, NeedModel, PatchBatchDocument, PredicateDefinition } from '@/libs/Api';
import { terminationReasonsStore } from '@/libs/termination-reasons/+state/store';
import { CrudAction, CrudReponse, CrudResponseAction } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import Page from '@/Page.vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';

import TerminationReasonDialog from '@/libs/settings/components/TerminationReasonDialog.vue';
import DeleteDialog from '@/libs/common/components/DeleteDialog.vue';

import draggable from 'vuedraggable'
import { CrudQueryPredicate } from '@/libs/core/+state/models/crud-query-predicate';

@Component({
    components: {
        TerminationReasonDialog,
        draggable
    }
})
export default class Needs extends Page {

    filterActive = true;
    subscribtion: any = null;
    items: NeedModel[] = [];
    @Prop() tenantId!: string;

    get loading(): boolean {
        return terminationReasonsStore.useGetter(CrudGetter.Pending);
    }

    get newPosition(): number {
        return this.items.length > 0 ? this.items.max(x => x.position!) + 1 : 1;
    }

    @Ref() dialog!: TerminationReasonDialog;
    
    mounted () {
        this.loadItems();
    }

    destroyed () {
        if (typeof this.subscribtion == "function")
            this.subscribtion();
    }

    loadItems () {
        let filters: CrudQueryPredicate[] = [];
        terminationReasonsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<TerminationReasonModel>([
            { field: "name", index: 1, order: "asc" }
        ], filters));
        this.subscribe(terminationReasonsStore, CrudReponse.GetAll).then((e: TerminationReasonModel[]) => {
            this.items = e;
        });
    }

    createItemClick () {
        this.dialog.open();
    }

    openItemClick (v: TerminationReasonModel) {
        this.dialog.open(v.id);
    }

}
